const randomizeOptions = questions => {
    let randomizedOptions = []
    for (let i = 0; i < 10; i++) {
        const options = questions[i].options.sort( () => .5 - Math.random() )
        randomizedOptions.push(options)
    }
    return randomizedOptions
}

export default randomizeOptions